module.exports = __webpack_public_path__ + "images/punkt_kolo_pom.png?15d2669110b269e3e6434296df0e7550";